var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAw = function SvgAw(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21724_19602",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21724_19602)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#5B85C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 15,
    width: 1.25,
    height: 20,
    transform: "rotate(90 20 15)",
    fill: "#F3D74C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12.5,
    width: 1.25,
    height: 20,
    transform: "rotate(90 20 12.5)",
    fill: "#F3D74C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97271 3.28193L5.83203 2.90175L5.69135 3.28193L5.04006 5.04202L3.27998 5.69331L2.8998 5.83398L3.27998 5.97466L5.04006 6.62595L5.69135 8.38604L5.83203 8.76622L5.97271 8.38604L6.624 6.62595L8.38409 5.97466L8.76426 5.83398L8.38409 5.69331L6.624 5.04202L5.97271 3.28193Z",
    fill: "#C2343C",
    stroke: "#F6F8FA",
    strokeWidth: 0.3
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAw);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/aw.26d5ab2269af6d9759bb0224f7b193a8.svg";